import { ErrorOutline } from '@mui/icons-material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, Typography } from '@mui/material';
import React from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import awsRum from '../../../../../awsRum';
import PageContentLayout from '../../../../Layouts/PageContentLayout';
import PageHeader from '../../../../Layouts/PageHeader';
import PageLayout from '../../../../Layouts/PageLayout';
import StyledBox, { ButtonRow } from './styles';

function ErrorFallback({ error }: FallbackProps) {
  const { t } = useTranslation();

  return (
    <PageLayout>
      <PageHeader title={t('error.title')} />
      <PageContentLayout>
        <StyledBox>
          <ErrorOutline />
          <Typography>{t('error.text')}</Typography>
          <Typography>{error.message}</Typography>
          <ButtonRow>
            <Button onClick={() => window.location.reload()}>
              <RefreshIcon />
              {t('error.reload-page')}
            </Button>
            <Button onClick={() => window.location.replace(window.location.href.split('#')[0])}>
              <RefreshIcon />
              {t('error.reload-from-home')}
            </Button>
          </ButtonRow>
        </StyledBox>
      </PageContentLayout>
    </PageLayout>
  );
}

export default function PageErrorBoundary(props: { children: React.ReactNode; extraResetKeys?: unknown[] }) {
  const { children, extraResetKeys = [] } = props;
  return (
    <ErrorBoundary
      resetKeys={[children, ...extraResetKeys]}
      FallbackComponent={ErrorFallback}
      onError={(error: Error) => {
        awsRum?.recordError(error);
        console.error(error);
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
